export const se = {
	childTest: `Välkommen till testet`,
	welcomeToTest: `Välkommen till testet`,
	literateChildTest: `Dysmate test`,
	youAreReady: `Du är redo`,
	ready: `redo`,
	chooseRole: `Välj roll`,
	chooseRoleHelp: `Välj vilken roll den här enheten ska ha`,
	chooseLanguage: `Välj Språk`,
	lang_no: `Norska (Bokmål)`,
	lang_nn: `Norska (Nynorsk)`,
	lang_se: `Svenska`,
	lang_de: `Tyska`,
	lang_nl: `Nederländska`,
	lang_en: `Engelska`,
	blue: `blå`,
	green: `grön`,
	pink: `rosa`,
	yellow: `gul`,
	red: `röd`,
	violet: `lila`,
	orange: `orange`,
	gray: `grå`,
	brown: `brun`,
	zebra: `zebra`,
	woman: `kvinna`,
	bike: `cykel`,
	table: `bord`,
	flower: `blomma`,
	moon:`måne`,
	star: `stjärna`,
	cake:`tårta`,
	apple: `äpple`,
	unknown: `okänd`,
	testadministrator: `Testadministratör`,
	testcandidate: `Testkandidat`,
	testkey: `Testnyckel`,
	emailaddress: `E-post adresse`,
	starttest: `Starta test`,
	candidateInstructions: `Skriv in kodnyckeln som visas på testadministratörens skärm`,
	candidateWelcome:`Välkommen till Dysmate-uppföljningstest.`,
	candidateGoodLuck:`Detta test består av sex olika delar och jag kommer att ge dig instruktioner inför varje moment. Skriv in din testnyckel och tryck på den blå knappen för att börja. Lycka till!`,
	gototest: `Gå till testet`,
	jumptotest: `Hoppa till test`,
	roomkey: `Testnyckel: {0}`,
	waitforadminstart: `Vänta till testadministratören startar testet`,
	done: `Ferdig`,
	name: `Navn`,
	sound: `Ljud`,
	helpBox1: `För att starta testet, fyll i all information nedan och anslut sedan ytterligare en enhet genom att följa instruktionerna nedan.`,
	helpBoxList1: `Öppna den här sidan på en annan enhet.`,
	helpBoxList2: `Välj testkandidat`,
	helpBoxList3: `Ange testnyckel ({0})`,
	helpBoxList4: `Klicka "Gå till testet"`,
	helpBoxList5: `När du är redo, tryck på "Starta test" längst ner på denna sida`,
	infoAboutCandidate: `Information om testkandidaten:`,
	generalInformation: `Allmän information`,
	notaBene: `OBS!`,
	candidateReminder: `Kom ihåg att det är kandidatens uppgifter som ska fyllas i, inte dina`,
	firstName: `Förnamn`,
	lastName: `Efternamn`,
	birthDate: `Födelsedatum`,
	gender: `Kön`,
	pickOne: `Välj en`,
	boy: `Man`,
	girl: `Kvinna`,
	unspecified: `Annan`,
	education: `Utbildning`,
	municipality: `Kommun`,
	county: `Län`,
	school: `Skola`,
	educationLevel: `Utbildningsnivå`,
	kindergarten: `Förskola`,
	primarySchool: `Grundskola`,
	juniorHighSchool: `Högstadium`,
	highSchool: `Gymnasium`,
	university: `Universitet`,
	other: `Annat`,
	pickYear: `Välj år`,
	pickClass: `Välj klass`,
	pickLevel: `Välj nivå`,
	pick: `Välj`,
	lastYearBeforeSchool: `sista året i förskola, förskoleklass`,
	class: `Årskurs`,
	classNum: `åk {0}`,
	consentText: `Som testadministratör bekräftar du att du har erforderligt samtycke från testkandidaten för att samla in personuppgifter och att dessa används enligt beskrivning`,
	literatePrivacyPolicy: `Literates integritetspolicy`,
	practiceTasks: `Övningsuppgift`,
	startPracticeTasks: `starta övningsuppgift`,
	listenToInstructions: `Lyssna på instruktionerna.`,
	waitingForCandidate: `Väntar på testkandidat`,
	logIn: `Logga in`,
	loginWithBankId: `Logga in med BankID genom att trycka på någon av knapparna nedan`,
	thisIsForTestAdmins: `Detta är för testadministratörer (dvs certifierade användare med en prenumeration)`,
	bankId: `BankID`,
	bankIdMobile: `BankID på Mobilen`,
	pauseBeforeNextTest: `Testet {0} är nu klart`,
	max2Listens: `Max två uppspelningar per ljudspår`,
	timeUsed: `Tid som förflutit: {0}`,
	start: `Start`,
	pause: `Paus`,
	stop: `Sluta`,
	reset: `Återställ`,
	testIsFinished: `Hela testet är nu klart`,
	TesFinished_Instruction_ONCANDIATESIDE: `Hela testet är nu klart`,
	testFinishedInstruction: `Svaren har sparats och du kan nu stänga denna sida eller starta ett nytt test.`,
	closeTest: `Stäng testet`,
	hotkeyDescription: `Markera korrekt eller felaktigt genom att klicka på knapparna nedan eller använda kortkommandon:`,
	hotkeyCorrect: `A: Korrekt`,
	hotkeyWrong: `L: Fel`,
	hotkeyButtonCorrect: `Korrekt (A)`,
	hotkeyButtonWrong: `Felaktigt (L)`,
	hotkeyButtonUnanswered: `Inget svar gavs (K)`,
	hotUnanswered:`K: Inget svar`,
	hotUnanswered2:`K: Inget svar gavs`,
	taskNum: `Uppgift: {0}`,
	taskNumOf: `Uppgift {0} av {1}`,
	correctAnswer: `Korrekt svar: {0}`,
	nextTest: `Nästa test`,
	correctAnswerGiven: `Rätt svar angivet`,
	expectedAnswer: `Förväntat svar: {0}`,
	clickStartWhenReady2:`Klicka på ”starta test” när du och testkandidaten är redo att börja testet.`,
	clickStartWhenReady: `Klicka på "starta test" när du och kandidaten är redo.`,
	whenReadyClickStart:`Klicka på ”starta test” när du och testkandidaten är redo.`,
	workingMemoryClickStart: ``,
	testDone: `Testet {0} är nu klart. Klicka på "Nästa test" när du och testkandidaten är redo att fortsätta.`,
	testDoneAndFinished: `Testet {0} är nu klart. Tryck på ”Nästa” när du och
testkandidaten är redo att avsluta uppföljningstestet.`,
	testDoneAndNext:`Testet {0} är nu klart. Klicka på "Nästa test"`,
	endTest: `Avsluta test`,
	continue: `Gå vidare`,
	testName_WorkingMemory: `Arbetsminne`,
	testName_WorkingMemoryNumbers: `Arbetsminne: Nummer`,
	testName_WorkingMemoryWords: `Arbetsminne: Ord`,
	testName_PhonemeDeletion: 'Fonemsubtraktionstest',
	testName_RapidNaming: `Snabb automatisk benämning (RAN)`,
	testName_OneMinute: `1-minuts ordavkodning`,
	testName_Spoonerism: `Spoonerismer`,
	testName_TestComplete: `Testet är klart`,
	testName_SentenceMemory: 'Meningsrepetition',
	testName_NonwordRepetition: 'Nonordsrepetition',
	iConsent: 'Jag samtycker',
	unilingual: 'Enspråkigt',
	bilingual: 'Tvåspråkigt',
	multilingual: 'Flerspråkigt',
	bilinguagualHomeQuestion:
		'Har du vuxit upp i ett en- eller tvåspråkigt hem?',
	om_testname: `1-minuts ordavkodningstest`,
	om_admin1: `Testkandidaten kommer att få se en lista med ord som hen ska läsa så snabbt
	och rätt hen kan under en minut. Du ser också orden på din skärm och
	registrerar om kandidaten läste rätt eller fel, eller inte läste ut ordet alls.`,
	om_admin2: `Detta test har ingen övningsuppgift, så påminn kandidaten att börja läsa direkt
	och var beredd att registrera svaren när testet startar.`,
	om_admin3:`Markera korrekt eller felaktigt svar genom att använda kortkommandon på
	tangentbordet.`,
	om_intro: `I det sista testet ska du läsa högt en lista med ord (uppifrån och ner) så fort och rätt du kan på en minut. Tryck på den blå knappen när du är redo att starta testet.`,
	rn_testname: `Snabb automatiserad benämning`,
	rn_admin1: `Detta test avser att mäta hur snabbt och korrekt testkandidaten kan benämna
en serie med kombinerade föremål och färger som visas på skärmen. Din
uppgift är att följa vilka föremål och färger i kombination som kandidaten
säger och markera om de stämmer med det som visas på din skärm.`,
rn_admin11:`Först kommer vi att gå igenom en övningsuppgift.`,
rn_admin12:`Tryck på ”Starta övningsuppgift” när du och testkandidaten är redo.`,
	rn_admin2: `I det här testet får testkandidaten se bilder och uppgiften är att benämna vad som syns på bilden så snabbt och korrekt som möjligt.`,
	rn_admin3: `I den första övningen ska testkandidaten namnge färgerna som visas på dennes skärm. Din uppgift är att hålla reda på vilka färger som läses upp.`,
	rn_adjustIfNotCorrect: `Om svaren som ges inte är korrekta måste du rätta testkandidaten nu. Om alla svar är korrekta kan du fortsätta.`,
	rn_colors: `röd - blå - grön - grå - orange`,
	rn_objects: `zebra - kvinna - bord - blomma - äpple`,
	rn_objectsWithColors: `Röd stjärna – blå blomma - grön cykel - brun måne - gul tårta`,
	rn_correctColors: `Rätta färger ges`,
	rn_correctItems: `Rätta svar ges`,
	rn_admin4: `I denna övning ska testkandidaten namnge föremålen som visas på skärmen. Din uppgift är att se till att testkandidaten säger rätt föremål i rätt ordning.`,
	rn_admin5: `Nu ska vi kombinera de två uppgifterna, och testkandidaten får i uppgift att namnge både färgen och föremålet på bilderna som visas.`,
	rn_admin6: `Var uppmärksam på vilka föremål och färger som namnges av kandidaten.`,
	rn_admin7: `Det var alla övningsuppgifter.`,
	rn_admin8: `Din uppgift är att följa vilka föremål och färger i kombination som kandidaten säger och om det stämmer med det som visas på din skärm.`,
	rn_admin9: `Markera om svaret är korrekt, felaktigt eller om inget svar gavs genom att
använda kortkommandon på tangentbordet.`,
	rn_admin10:`Om svaren som ges inte är korrekt kan du nu gå igenom och korrigera dessa
med testkandidaten innan ni påbörjar testet. Om alla svar är rätt kan du trycka
på ”Rätta svar ges”.`,
 	rn_admin13:`Övningsuppgiften är nu klar.`,
	rn_admin14:`Under testet är din uppgift att följa vilka föremål och färger i kombination som
kandidaten säger och om det stämmer med det som visas på din skärm.
Markera om svaret är korrekt, felaktigt eller om inget svar gavs genom att
använda kortkommandon på tangentbordet.`,
	rn_timeUsed: `Tid som förflutit: {0} sekunder`,
	rn_intro1: `Du kommer nu att få se några bilder på föremål med olika färger. Din uppgift
är att säga färgerna och föremålen så fort du kan. Låt oss börja med en
övningsuppgift.`,
	rn_intro2: `Lyssna noga på namnen på färgerna. röd – blå – grön – grå – orange. Nu är det din tur att säga färgerna så snabbt som du kan.`,
	rn_intro3: `Lyssna noga när jag säger namnen på föremålen zebra – kvinna – cykel – blomma – äpple. Nu är det din tur att säga vilka föremålen är så snabbt som du kan.`,
	rn_intro4: `Nu kommer du att få se en bild med både färger och föremål. Lyssna noga. Nu är det din tur att säga färgerna och föremålen så snabbt som du kan.`,
	rn_intro5: `När testet startar kommer du att få se de här föremålen och färgerna flera
gånger. Du ska följa raden och säga färgerna och föremålen så fort du kan utan
att hoppa över någon. Tryck på den blå knappen när du är redo att starta
testet.`,
	sp_testname: `Spoonerismer `,
	sp_admin_listen: `Lyssna om de nya ord testkandidaten säger stämmer med det Förväntade svaret på din skärm. Markera om testkandidaten lyckas byta de första ljuden på bägge orden eller endast ett eller om bägge är felaktiga genom att klicka på knapparna nedan eller använda kortkommandon (detta rekommenderas).`,
	sp_admin1: `I detta test kommer testkandidaten att få höra ordpar. Uppgiften är att så fort hen kan byta de första språkljuden i orden så att det blir två nya ord eller nonsensord. Till exempel blir orden  {0}{1}{2}`,
	sp_admin1part2: `Vi börjar med en övningsuppgift, tryck på ”starta övningsuppgift” när du och testkandidaten är redo.`,
	click_start: `Vi är nu färdiga med övningsuppgifterna. Påminn testkandidaten att vara uppmärksam på att det kommer byggs på med fler och fler siffror efter hand som kandidaten klarar uppgiften. Be eleven invänta signalen/"blipp" innan den svarar så att hen får med sig alla siffror.`,
	click_start_words: `Vi är nu färdiga med övningsuppgifterna. Påminn testkandidaten att vara uppmärksam på att det kommer byggas på med fler och fler ord efter hand som kandidaten klarar uppgiften. Be eleven invänta signalen/"blipp" innan den svarar så att hen får med sig alla orden.`,
	click_start2: ' När testkandidaten klickar på startknappen börjar testet.',
	sp_example1: `GUL-SOL blir SUL-GOL`,
	sp_example2:`MÅNE-VÄGG ➜ VÅNE – MÄGG`,
	sp_example3: `TJUV och HATT`,
	sp_example4: `HUV - TJATT`,

	sp_admin_example1: `GUL-SOL ➜ SUL-GOL`,
	sp_admin_example2:`MÅNE-VÄGG ➜  VÅNE – MÄGG`,
	sp_admin_example3: `TJUV-HATT ➜  HUV-TJATT`,
	sp_1correct: `1 Korrekt (L)`,
	sp_2correct: `2 Korrekt (A)`,
	sp_bothWrong: `Båda felaktiga (K)`,
	sp_admin2: `Testkandidaten kommer att säga ordpar där hen växlat de inledande språkljuden. Din uppgift är att lyssna om orden som testkandidaten säger stämmer överens med det som visas på din skärm.`,
	sp_admin3: `Lyssna på testkandidaten och kontrollera om orden hen säger stämmer överens med det som presenteras på din skärm.`,
	sp_instruction: `Lyssna på orden och växla sedan de första ljuden.`,
	sp_intro1: `I detta test kommer du få höra två ord, din uppgift är att byta plats på de första ljuden i orden så att det blir två nya ord eller nonsensord. Till exempel orden {0}, i nästa exempel blir {1}.  `,
	sp_intro1_2:`Kom ihåg att det inte är bokstaven du ska byta utan det första ljudet {0}  blir då {1}.`,
	sp_intro1_3: `När du är redo att göra övningsuppgiften kan du trycka på den blå knappen.`,
	sp_intro_reminder: `inte den första bokstaven`,
	sp_intro_reminder2: `första ljudet`,

	sp_admin_note:`Markera om testkandidaten lyckas byta de första ljuden på bägge orden
eller endast ett eller om bägge är felaktiga. Det spelar inte någon roll i
vilken ordning testkandidaten återger orden, böv-lil blir också rätt.
Markera svaren genom att trycka på knapparna nedan eller använda
kortkommandon på tangentbordet (detta rekommenderas):`,
	sp_intro3: `Vi är nu färdiga med övningsuppgiften. När du trycker på den blå knappen startar testet. Du ska då lösa uppgifterna så snabbt och rätt du kan. Jag kommer nu bara att säga orden och du byter plats på de första ljuden och säger vad det blir. `,
	ws_testname: `Arbetsminne`,
	ws_testname_admin: `Arbetsminne`,
	wsn_testname: `Arbetsminne (siffror)`,
	wsw_testname: `Arbetsminne (ord)`,
	ws_admin1: `Detta test är avsett att mäta arbetsminneskapacitet.`,
	wsn_admin2: `Testkandidaten kommer att höra siffror som hen sedan ska upprepa i omvänd ordning. Du kontrollerar om ordningen stämmer överens med det du ser på din skärm.`,
	wsw_admin2: `Testkandidaten kommer att höra några ord som hen ska upprepa i omvänd
ordning. Du kontrollerar om ordföljden stämmer överens med det du ser på
din skärm.`,
	wsw_admin2part2: `Detta test har ingen övningsuppgift utan börjar direkt med testuppgifterna.`,
	wsn_admin2part2: ``,
	wsw_admin2part3:`Påminn testkandidaten att vara uppmärksam på att det kommer att byggas på
med fler och fler ord efter hand som kandidaten klarar uppgifter. Be eleven
invänta
signalen/”blipp” innan den svarar så att hen får med sig alla ord.`,
	wsn_admin3: `Testkandidaten kommer att höra siffror som hen sedan ska upprepa i omvänd ordning. Du kontrollerar om ordningen stämmer överens med det du ser på din skärm.`,
	wsw_admin3: `Lyssna på testkandidaten och kontrollera om hen säger den rätta ordföljden som visas på din skärm.`,
	wsn_intro1: `Nu kommer jag att säga siffror, lyssna noga för när jag är klar ska du upprepa siffrorna men i omvänd ordning. Så om jag säger 1-3, ska du istället säga, 3-1. `,
	wsn_intro2: `Var uppmärksam för det kommer att byggas på med fler siffror efter hand som du klarar uppgifterna. Invänta signalen – ett litet blipp, innan du upprepar siffrorna.`,
	wsn_intro3: `Låt oss börja med en övningsuppgift.`,
	wsw_intro1: `Jag kommer nu istället att säga ord, lyssna noga för när jag är klar ska du upprepa orden i omvänd ordning.`,
	wsw_intro2: `Till exempel om jag säger bil – boll, ska du säga, boll-bil.`,
	wsw_intro3:`Var uppmärksam för det kommer att byggas på med flera ord efter hand som du klarar uppgifterna. Invänta signalen – ett litet blipp, innan du upprepar orden. Tryck på den blå knappen när du är redo att börja.`,
	wsn_test1: `Lyssna på siffrorna och upprepa dem i omvänd ordning.`,
	wsw_test1: `Lyssna på orden och upprepa dem i omvänd ordning.`,

		
	//Admin files
	sm_testname:`Meningsrepetition`,
	sm_intro1:`Jag kommer nu att läsa upp en mening för dig. När jag är klar ska du upprepa meningen exakt så som jag sa den. Låt oss börja med en övningsuppgift.`,
	
	sm_intro2: ``,
	nono_intro1: `I den här uppgiften kommer du att få höra några påhittade ord som inte betyder någonting alls. Din uppgift är att upprepa dem så exakt som möjligt. Först säger jag ordet och sen ska du säga samma ord. Därefter får du en annan uppgift som du ska lösa. När det har gått 10 sekunder så kommer jag att be dig att säga det påhittade ordet en gång till. Låt oss börja med en övningsuppgift.`,
	sm_trial_admin_info_1: `Det är tillåtet att upprepa övningsuppgiften tills eleven har förstått uppgiften och löser den korrekt. När ni känner er redo går ni vidare genom att du som testledare markerar uppgiften som ”korrekt återgiven”.`,
	sm_trial_admin_info_1_2:`Med undantag av övningsuppgifterna är det inte tillåtet att upprepa meningarna när testet väl startat. Om testkandidaten då frågar vad som sades, be hen att upprepa meningen så gott hen kan. `,
	sm_trial_admin_info_2: `Du registrerar fel genom att trycka på (+), och tar bort fel genom att trycka på (-). Du kan också registrera om eleven återger hela meningen korrekt -> ”Korrekt återgiven”, inte minns meningen -> ”Minns inte” eller återställa resultaten -> ”Återställ”.`,
	sm_trial_admin_info_3_title: `Vad som räknas som fel:`,
	sm_trial_admin_info_3_a: `• Utelämnat ord`,
	sm_trial_admin_info_3_b: `• Användning av annat ord, även om det har samma betydelse.`,
	sm_trial_admin_info_3_c: `• Omkastning av ordföljden på två ord räknas som ett fel`,
	sm_trial_admin_info_3_d: `• Tillägg av ord`,
	sm_trial_admin_info_3_e: `• Grammatiska fel, ordböjningar och ändelser`,
	sm_trial_admin_info_4: `Uttalsfel eller dialektal variation hos testkandidaten ska inte räknas som fel om dessa är kända av testledaren.`,
	sm_admin1: `I detta test kommer testkandidaten att få höra meningar som denne ska upprepa och återge så korrekt som möjligt. Din uppgift är att registrera om eleven lyckas återge meningen korrekt eller inte.`,
	sm_admin1_2:`Du registrerar fel genom att trycka på (+), och tar bort fel genom att trycka på
(-). Du kan också registrera om eleven återger hela meningen korrekt ->
”Korrekt återgiven”, inte minns meningen -> ”Minns inte” eller återställa
resultaten -> ”Återställ”.`,
	sm_admin1_3:``,
	sm_admin_intro_4:`Vi börjar med en övningsuppgift. Tryck på ”starta övningsuppgift” när du och
testkandidaten är redo att börja.`,
	sm_admin1_4:`Vi börjar med en övningsuppgift, tryck på ”starta övningsuppgift” när du och testkandidaten är redo.`,
	sm_trialNumber_of:`Övningsuppgift {0} av {1}`,
	sm_trial_admin_info:`sm_trial_admin_info`,
	sm_admin2:`Vi är nu färdiga med övningsuppgiften. Tryck på ”Starta test” när du och testkandidaten är redo att börja`,
	sm_test_admin_info_1:`Med undantag av övningsuppgifterna är det nu inte tillåtet att upprepa meningarna. Om testkandidaten frågar vad som sades, be hen att upprepa meningen så gott hen kan.`,
	startTrial:`startTrial`,
	sm_test_admin_info:`sm_test_admin_info`,
	sm_mistakes_label:`Antal fel`,
	confirmAndNext:`Bekräfta`,
	unansweredAndNext:`unansweredAndNext`,
	setMistakesNoSubmit:`setMistakesNoSubmit`,
	sm_hotkey_inc_dec:`sm_hotkey_inc_dec`,
	
	//Test.js
	sm_test_listen_repeat: `sm_test_listen_repeat`,
	sm_trial_listen_repeat: `sm_trial_listen_repeat`,
	sm_intro_after_trial_2: `Så, då var vi klara med övningsuppgiften. Jag kommer att läsa fler meningar men nu får jag inte längre upprepa dem för dig. Du måste därför lyssna noga så att du kan upprepa meningarna så exakt som möjligt.`,
	sm_intro_after_trial_3: `Tryck på den blå knappen när du är redo att starta testet.`,

	warning1: `Varning 1 - `,
	warning1text: `Det verkar som att testet med denna testnyckel inte har startat ordentligt ännu. Testadministratören måste starta rätt test från`,
	myTests: `Mina tester`,
	warning2: `Varning 2`,
	warning2text: `- Det verkar som att du har inaktiverat spårning över flera webbplatser i din webbläsare. För att använda våra tjänster måste du aktivera den. Tryck`,
	linkForInstructions: `här`,
	remainingTime: `Återstående tid`,
	remainingTimeOneMiniute: `Återstående tid:`,
	trialIsNowOver: `Tryck på den blå knappen när du är redo att starta testet.`,
	//PhonemeDeletion
	pd_testname: 'Fonemsubtraktionstest',
	pd_admin1:
		'Testkandidaten får instruktioner upplästa genom övningsuppgifterna. Du måste se till att rätt svar ges. Om svaret är felaktigt måste du rätta kandidaten.',
	pd_admin2:
		'Lyssna på testkandidaten och notera om hen säger rätt svar. Kandiaten kommer att få uppgifter som "Kan du säga ris utan /r/". Nedan visas både det ursprungliga ordet och det förväntade svaret.',
	pd_intro1:
		'I detta test kommer jag att be dig säga några ord och därefter fråga dig vilket ord det blir när vi tar bort ett visst ljud. Till exempel, om vi tar bort /s/ från stall får vi ordet tall.',
	pd_intro2:
		'Innan testet börjar, gör vi med några övningsexempel tillsammans.',
	pd_introDone:
		'Jättebra! Du klarade övningsuppgifterna. I testet ska du nu göra precis samma sak, det vill säga säga högt vilket ord det blir när du tar bort ett visst ljud. Du har 30 sekunder på dig att svara på en uppgift, sedan går vi vidare till nästa. Tryck på den blå knappen när du känner dig redo att starta testet.',
	pd_testInstruction:
		'Lyssna på uppgiften och säg vilket ord det blir när ljudet tas bort.',
	wd_writeHere: 'Skriv ordet här',
		
	nw_testName:`Nonordsrepetition`,
	nonword_admin_intro_1: `I detta test får testkandidaten höra ett nonsensord. Kandidaten ska upprepa ordet och återge det så korrekt som möjligt. Därefter följer en distraktion i form av en annan uppgift som kandidaten ska lösa. Efter 10 sekunder ombeds kandidaten att återigen säga nonsensordet.`,

	nonword_admin_intro_2: `Din uppgift är att registrera om eleven lyckas upprepa nonsensordet korrekt både vid direkt repetition och fördröjd repetition (efter distraktionen). Du registrerar om svaret är ”Korrekt”, ”Inte besvarat” eller ”Felaktigt”. Distraktionerna startar direkt efter att du fyllt i resultatet på den första repetitionen. Distraktionen poängsätts inte.`,

	nonword_admin_intro_3: `Övningsuppgiften poängsätts inte.`,

	nonword_admin_intro_4:`Tryck på ”starta övningsuppgift” när du och testkandidaten är redo.`,

	expectedSentence: `Korrekt mening: `,
	nonword_admin_trial_1: `Din uppgift är att registrera om eleven lyckas upprepa nonsensordet korrekt både vid direkt repetition och fördröjd repetition (efter distraktionen). Du registrerar om svaret är ”Korrekt”, ”Inte besvarat” eller ”Felaktigt”. Distraktionerna startar direkt efter att du fyllt i resultatet på den första repetitionen. Distraktionen poängsätts inte.`,
	nonword_admin_trial_2: `Övningsuppgiften poängsätts inte.`,
	nonword_delayed: `2. Fördröjd repetition (efter 10 sekunder)`,
	notAnswered: `Inte besvarat`,
	nonword_intro_after_trial_1: `Nu vet du vad du ska göra, så nu kan vi börja med de riktiga uppgifterna.`,
	nonword_intro_after_trial_2: `Kom ihåg att du bara får höra det påhittade ordet en gång, så lyssna noga på vad jag säger.`,
	nonword_intro_after_trial_3: `Tryck på startknappen när du är redo.`,
	nonword_admin_test_info_1: `Testkandidaten hör nonsensordet en gång. Kandidaten ska återge ordet direkt (direkt repetition) och igen efter 10 sekunder (fördröjd repetition). `,
	nonword_admin_test_info_2: `Du registrerar bägge svaren. Korrekt (1 poäng), Inte besvarat (0 poäng), Felaktigt (0 poäng). Maxpoäng per uppgift är 2 poäng. `,
	nonword_admin_wait_post_trial:`Klicka på ”start” när du och testkandidaten är redo att starta testet.`,
};

export default se;
